import React from "react";
import classes from "./InviteCode.module.scss";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import * as helpers from "../../helpers";
import Main from "../../hoc/Layout/Main";
import MainTitleSearch from "../../components/UI/MainTitle/MainTitlePurple";
import ButtonBePremium from "../../components/Buttons/ButtonBePremium";
import GoPremium from "../GoPremium";
import { Box, Typography } from "@mui/material";
import useInviteCodeLogic from "./hooks/useInviteCodeLogic";
import LinkInviteCode from "./InviteCardGroup/InviteContainer/LinkInviteCard/LinkInviteCard";
import CodeInviteCard from "./InviteCardGroup/InviteContainer/CodeInviteCard/CodeInviteCard";
import InviteCards from "./InviteCardGroup/InviteCards/InviteCards";

const InviteCode = (props) => {
  // Lógica do hook customizado que retorna os dados e funções relacionadas ao código de convite
  const {
    session,
    plans,
    inviteCode,
    inviteCodeLink,
    isCodeCopied,
    isLinkCodeCopied,
    isFetching,
    code_error,
    hasError,
    fetchCodeHandler,
    copyToClipboardHandler,
    copyLinkToClipboardHandler,
    invitationsAvailable,
    permissionCount,
    activeUsersCount,
  } = useInviteCodeLogic();

  const { t } = useTranslation();

  // Verifica se o usuário tem plano premium
  const isPremium =
    session && !helpers.isFree(session?.permissions, plans?.permissions);

  // Componente que exibe mensagem para atualizar plano (quando atinge o limite de usuários)
  const InviteLimitAlert = ({ t }) => (
    <Box className={classes.InfoBePremium} style={{ textAlign: "center" }}>
      <Typography
        sx={{
          color: "#662D91;",
        }}
      >
        {t("global.plan_user_limit_hit")}
      </Typography>

      <ButtonBePremium
        style={{
          marginTop: "20px",
          backgroundColor: "#662D91",
          borderRadius: "15px",
          color: "#FBF6FF",
          fontSize: "15px",
        }}
        text={t("inviteUsers.acquire_more_users")}
      />
    </Box>
  );

  // Exibe o alerta para o usuário caso o limite de convites do plano tenha sido atingido
  const upgradeAlert = hasError ? <InviteLimitAlert t={t} /> : null;

  // Renderização dos cards para usuários com plano premium
  const renderPremiumContent = () => (
    <Box className={classes.InviteCardsWrap}>
      {/* Card Link Convite */}
      <LinkInviteCode
        inviteCodeLink={inviteCodeLink}
        isLinkCodeCopied={isLinkCodeCopied}
        isFetching={isFetching}
        fetchCodeHandler={fetchCodeHandler}
        copyLinkToClipboardHandler={copyLinkToClipboardHandler}
        code_error={code_error}
        upgradeAlert={upgradeAlert}
        hasError={hasError}
      />
      {/* Card Código Convite */}
      <CodeInviteCard
        inviteCode={inviteCode}
        isCodeCopied={isCodeCopied}
        isFetching={isFetching}
        fetchCodeHandler={fetchCodeHandler}
        copyToClipboardHandler={copyToClipboardHandler}
        code_error={code_error}
        upgradeAlert={upgradeAlert}
        hasError={hasError}
      />
    </Box>
  );

  // Renderização para usuários gratuitos (exibe mensagem + cards com blur)
  const renderFreeContent = () => (
    <>
      <GoPremium
        title="global.goPremiumInvite"
        info="global.goPremiumInviteInfo"
      />
      <span className={classes.blurBG}></span>

      {/* Reusa os cards do plano premium */}
      {renderPremiumContent()}
    </>
  );

  return (
    <Box className={classes.ChangeUser + " row"}>
      {/* Cabeçalho da página */}
      <MainTitleSearch full hasBG title={t("global.invite_user")}>
        <Typography className={classes.SubTitle}>
          {t("inviteUsers.invite_your_users")}
        </Typography>
      </MainTitleSearch>
      <Main full>
        {/* Renderiza os cards na parte superior */}
        <InviteCards
          invitationsAvailable={invitationsAvailable}
          activeUsersCount={activeUsersCount}
          permissionCount={permissionCount}
        />
        <Box className={classes.TitleInvite}>
          {t("inviteUsers.choose_invite_type")}
        </Box>

        {/* Exibe conteúdo com base no tipo de usuário (premium ou gratuito) */}
        {isPremium ? renderPremiumContent() : renderFreeContent()}

        {/* Informações adicionais sobre o uso do sistema de convites */}
        <Box className={classes.Infos}>
          <Box className={classes.TitleInfos}>
            <FontAwesomeIcon icon={faInfoCircle} /> {t("inviteUsers.infos")}
          </Box>
          <Typography>{t("inviteUsers.info_one")}</Typography>
          <Typography>{t("inviteUsers.info_two")}</Typography>
          <Typography>{t("inviteUsers.info_three")}</Typography>
        </Box>
      </Main>
    </Box>
  );
};

export default InviteCode;
